export default __webpack_public_path__ + "resources/icons/n441-1948.webp";